import { render, staticRenderFns } from "./BlockTracks.vue?vue&type=template&id=4cf968d8"
import script from "./BlockTracks.vue?vue&type=script&lang=js"
export * from "./BlockTracks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports